import { render, staticRenderFns } from "./alisms_config.vue?vue&type=template&id=327aab8f&scoped=true"
import script from "./alisms_config.vue?vue&type=script&lang=js"
export * from "./alisms_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327aab8f",
  null
  
)

export default component.exports